import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Component, Inject } from '@angular/core';
import { MasterDetailListEntry, TranslationService } from '@sdbn/common';
import { FilterMailSchedule } from '../../filter-administration.model';

@Component({
  selector: 'app-filter-mail-schedule',
  templateUrl: './filter-mail-schedule.component.html',
  styleUrls: ['./filter-mail-schedule.component.scss']
})
export class FilterMailScheduleComponent {

  saveEnabled: boolean;
  cancelEnabled: boolean;

  newId = -1;

  filterMailSchedules = new Array<FilterMailSchedule>();
  visiblefilterMailSchedules = new Array<FilterMailSchedule>();
  selectedEntry: FilterMailSchedule;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<FilterMailScheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.filterMailSchedules != null) {
      for (const schedule of data.filterMailSchedules) {
        this.filterMailSchedules.push(new FilterMailSchedule(schedule))
      }
    }

    this.updateVisibleMailSchedules();
    this.setSelectedEntry(this.visiblefilterMailSchedules[0]);
    this.updateScheduleTitles();
    this.updateEnablement();
  }

  public onCancel() {
    this.dialogRef.close();
  }

  public onSave() {
    this.dialogRef.close(this.filterMailSchedules);
  }

  handleSelectionChange(selection: any) {
    this.setSelectedEntry(selection);
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    const schedule = entry as FilterMailSchedule;
    if (schedule.id >= 0) {
      schedule.deleted = true;
    } else {
      const index = this.filterMailSchedules.indexOf(schedule);
      this.filterMailSchedules.splice(index, 1);
    }


    this.updateVisibleMailSchedules();
    this.setSelectedEntry(this.visiblefilterMailSchedules[0]);
    this.updateEnablement();
  }

  onAddEntry($event) {
    this.addEntry();
  }

  private setSelectedEntry(selection: any) {
    this.selectedEntry = selection;
  }

  private addEntry() {
    this.selectedEntry = new FilterMailSchedule({ id: this.newId-- });
    this.filterMailSchedules.push(this.selectedEntry);
    this.updateVisibleMailSchedules();
    this.updateEnablement();
  }


  onEntryChanged() {
    this.updateEnablement();
    this.updateScheduleTitle(this.selectedEntry);
  }

  private updateEnablement() {
    for (const schedule of this.visiblefilterMailSchedules) {
      if (!schedule.deleted && !schedule.isValid) {
        this.saveEnabled = false;
        return;
      }
    }
    this.saveEnabled = true;
  }

  private updateScheduleTitles() {
    for (const schedule of this.visiblefilterMailSchedules) {
      this.updateScheduleTitle(schedule);
    }
  }

  private updateScheduleTitle(schedule: FilterMailSchedule) {
    let title = schedule.timeOfDay == null ? '-:-' : schedule.timeOfDay;

    if (schedule.monday) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.monday.short')
    }
    if (schedule.tuesday) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.tuesday.short')
    }
    if (schedule.wednesday) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.wednesday.short')
    }
    if (schedule.thursday) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.thursday.short')
    }
    if (schedule.friday) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.friday.short')
    }
    if (schedule.saturday) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.saturday.short')
    }
    if (schedule.sunday) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.sunday.short')
    }
    if (schedule.periodic) {
      title += ' ' + this.translationService.translate('tmc-yard.entity.filter-mail-schedule.periodic.short') + ' ' + schedule.periodicInterval
    }
    schedule.title = title;
  }

  private updateVisibleMailSchedules() {
    this.visiblefilterMailSchedules = this.filterMailSchedules.filter(s => s.deleted != true);
  }
}
